/**
 * Z-index scale for the Filter V2 popovers. Radix portals every popover to
 * <body>, so nesting only works if each level sits above its parent. When a
 * filter surface is rendered inside a raised container (e.g. the create/edit
 * metric dialog raises its "New filter" panel above the modal), the default
 * z-50 popovers fall behind it, so we pin an explicit, self-consistent scale.
 *
 * - LEVEL 1: segment/row popovers (field, operator, value) and applied chips.
 * - LEVEL 2: dropdowns opened from within a LEVEL 1 popover (sort, special
 *   time/interaction value editors and their own nested rows).
 *
 * `overflow-hidden!` overrides the shared PopoverContent `overflow-y-auto` so
 * nested menus own their own scroll (field list / values), instead of the
 * outer shell fighting them for wheel events.
 */
export const FILTER_CONTENT_V2_POPOVER_CONTENT_CLASS =
  'z-1000! overflow-hidden! max-h-(--radix-popover-content-available-height)';
export const FILTER_CONTENT_V2_NESTED_POPOVER_CONTENT_CLASS = 'z-1010!';

/** Prevents Dialog/parent scroll lock from stealing wheel events (radix-ui/primitives#1159). */
export const stopPopoverWheelPropagation = (event: { stopPropagation: () => void }) => {
  event.stopPropagation();
};
